import type { InboundRequest } from '../../types/taActionBoard';

/**
 * Why a card in the "No role in Lever" group is there on purpose.
 *
 * Requests used to be filed under whichever Lever application came back first, which put live
 * questions under closed and internal postings — a candidate rejected for `Senior Data Analyst`
 * appeared under an internship closed since February. The server now assigns no role wherever it
 * cannot stand behind one, and saying WHICH uncertainty applies is what makes the empty group
 * readable: without a word on the card, "no role" looks like the Lever join simply failed.
 *
 * Its own module because InboundCard.tsx is at the repo's 500-line limit.
 */
export const ROLE_UNKNOWN_COPY: Record<
  NonNullable<InboundRequest['roleUnknownReason']>,
  { label: string; title: string }
> = {
  ambiguous: {
    label: 'role unclear',
    title:
      'They have more than one application from around the same time, on different roles — which one this email is about cannot be told apart, so no role is assumed.',
  },
  internal_posting: {
    label: 'role unclear',
    title:
      'Their most recent application is on an internal pipeline posting, not a role they applied to, so no role is assumed.',
  },
  closed_posting: {
    label: 'closed role',
    title:
      'Their most recent application is archived and its posting is closed, so this request is not filed under that role.',
  },
};
